import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EndpointLocationProviderService } from '../../shared/services/endpoint-location-provider.service';

@Injectable()
export class UsuarioService {

    private handleError: HandleError;
    private env = environment;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('UsuarioService');
    }

    add(usuario): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/Add/`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Adicionar Usuário', []))
            );
    }

    get(idUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/Get/${idUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar Usuário', []))
            );
    }

    getUsuarioPermissoes(idUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetUsuarioPermissoes/${idUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar lista de permissões do Usuário', []))
            );
    }

    getByCPF(CPF): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetByCPF/${CPF}`)
            .pipe(
                catchError(this.handleError('Buscar Usuário pelo CPF', []))
            );
    }

    getList(usuario, idEntidade, EntidadeTipo): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetList/${idEntidade}/${EntidadeTipo}`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Buscar lista de Usuários', []))
            );
    }

    getListExcel(usuario, idEntidade, EntidadeTipo): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetListExcel//${idEntidade}/${EntidadeTipo}`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Buscar lista de Usuários para gerar excel', []))
            );
    }

    getHistorico(idUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetHistorico/${idUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar histórico do Usuário', []))
            );
    }

    getListEntidadesUsuario(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetListEntidadesUsuario/`)
            .pipe(
                catchError(this.handleError('Buscar lista de entidades do Usuário', []))
            );
    }

    getListEntidadesCoordenador(idUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetListEntidadesCoordenador/${idUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar lista de ARs e ACs onde o usuário é coordenador', []))
            );
    }

    removerPermissoes(usuario): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/RemoverPermissoes/`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Remover permissões  do Usuário', []))
            );
    }

    isDisableable(usuario): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/isDisableable/`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Verificar se o usuário pode ser desabilitado', []))
            );
    }

    changeStatus(usuario): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/ChangeStatus/`, JSON.stringify(usuario))
            .pipe(
                catchError(this.handleError('Alterar status do Usuário', []))
            );
    }

    addAssinaturaTermoResponsabilidade(assinaturaTermoResponsabilidade): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/AddAssinaturaTermoResponsabilidade/`, JSON.stringify(assinaturaTermoResponsabilidade))
            .pipe(
                catchError(this.handleError('Adicionar Termo de Responsabilidade', []))
            );
    }

    getBase64TermoResponsabilidade(idUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/GetBase64TermoResponsabilidade/${idUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar base64 do Termo de Responsabilidade', []))
            );
    }

    getListByUsuario(idUsuario, idSistema, tipoUsuario): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PERMISSAO)}/api/Permissao/GetListByUsuario/${idUsuario}/${idSistema}/${tipoUsuario}`)
            .pipe(
                catchError(this.handleError('Buscar lista de permissões do Usuário', []))
            );
    }

    getListPermissaoacaoByUsuarioTipo(usuarioTipo): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/getListPermissaoacaoByUsuarioTipo/${usuarioTipo}`)
            .pipe(
                catchError(this.handleError('Buscar lista de permissões ações por tipo de usuário.', []))
            );
    }

    converterPermissoes(usuarioTipo): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_USUARIO)}/api/Usuario/ConverterPermissoes/${usuarioTipo}`)
            .pipe(
                catchError(this.handleError('Converter as permissões do usuário atual.', []))
            );
    }
}
